/* eslint-disable max-len */
import { useCallback } from 'react';
import useRequestConfigs from '../useRequestConfigs';
export default function useOnProductCardClick(cioClient, callback) {
    const { getRequestConfigs } = useRequestConfigs();
    const requestConfigs = getRequestConfigs();
    if (!requestConfigs) {
        throw new Error('This hook is meant to be used within the CioPlp provider.');
    }
    return useCallback((event, item, selectedVariationId) => {
        const { itemName, itemId, variationId } = item;
        const { query, section } = requestConfigs;
        if (cioClient) {
            // Track search result click
            if (query) {
                cioClient.tracker.trackSearchResultClick(query, {
                    itemId,
                    itemName,
                    variationId: selectedVariationId || variationId,
                    section,
                });
            }
        }
        if (callback)
            callback(event, item);
    }, [callback, cioClient, requestConfigs]);
}
